// extracted by mini-css-extract-plugin
export default {"comunicado_relatorios":"RelatorioDadosStyle_comunicado_relatorios__H-CUt"};